import styled from 'styled-components';

export const Container = styled.div``;

export const Tabela = styled.div`
  display: flex;
  place-content: center;
  margin: 16px 8px;
  background-color: #fbfbfb;
  width: 90vw;

  .react-grid-Grid {
    margin-bottom: 8px;
    user-select: text;
  }

  .react-grid-Cell__value {
    padding: 8px 0px;
  }

  input {
    width: 100%;
    padding: 4px;
    border: 1px solid #bbb;
    border-radius: 8px;
  }

  button {
    border: 1px solid #2c73e9 !important;
    border-radius: 8px;
    color: #2c73e9 !important;
    font-size: 16px !important;
    font-weight: 500 !important;
    margin-bottom: 8px !important;
  }
`;

export const Info = styled.main`
  max-width: 1120px;
  margin: 0 auto;

  .tabela {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;

    place-content: center;

    align-items: center;
    justify-items: center;
  }
`;

export const MoreInfo = styled.div`
  max-width: 1120px;
  display: flex;
  flex-wrap: wrap;

  height: 90vh;

  place-content: center;

  align-items: center;
  justify-items: center;
  margin: 64px 16px;
`;

export const Cards = styled.div`
  display: flex;
  flex-wrap: wrap;

  place-content: center;

  align-items: center;
  justify-items: center;
  margin: 24px auto;
`;

export const SalesChart = styled.div`
  display: flex;
  flex-wrap: wrap;

  margin: auto 16px;

  height: 90vh;

  place-content: center;

  align-items: center;
  justify-items: center;
`;

export const Botoes = styled.div`
  display: flex;
  flex-wrap: wrap;

  margin-bottom: -56px;

  place-content: center;

  align-items: center;
  justify-items: center;

  div {
    width: 100vw;

    border: 1px solid rgba(100, 100, 100, 0.2);
    border-radius: 10px;

    margin-top: -64px;
  }

  button {
    width: 128px;
    height: 48px;
    margin-left: 8px;
    margin-right: 8px;
    margin-top: 8px;
    font-weight: 600;
    border: 1px solid;
    border-radius: 8px;
    background: transparent;
    padding: 0 16px;
  }

  .top-produtos {
    border-color: #e9482c;
    color: #e9482c;
  }

  .top-produtos-download {
    background-color: #e9482c;
    color: #fff;
  }

  .vendas-por-classe {
    border-color: #e9782c;
    color: #e9782c;
  }

  .vendas-por-classe-download {
    background-color: #e9782c;
    color: #fff;
  }

  .curva-abc {
    border-color: #652ce9;
    color: #652ce9;
  }

  .curva-abc-download {
    background-color: #652ce9;
    color: #fff;
  }
`;
